import { TenantEntity } from '../TenantEntity'

export class OfficeInvoiceTitle extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get officeId() {
    return this._data.officeId
  }
  set officeId(officeId) {
    this._data.officeId = officeId || 0
  }
  get invoiceTitle() {
    return this._data.invoiceTitle
  }
  set invoiceTitle(invoiceTitle) {
    this._data.invoiceTitle = invoiceTitle
  }
  get taxAccount() {
    return this._data.taxAccount
  }
  set taxAccount(taxAccount) {
    this._data.taxAccount = taxAccount
  }
  get invoiceAddress() {
    return this._data.invoiceAddress
  }
  set invoiceAddress(invoiceAddress) {
    this._data.invoiceAddress = invoiceAddress
  }
  get enterpriseWechatPayCompany() {
    return this._data.enterpriseWechatPayCompany
  }
  set enterpriseWechatPayCompany(enterpriseWechatPayCompany) {
    this._data.enterpriseWechatPayCompany = enterpriseWechatPayCompany
  }
  get phone() {
    return this._data.phone
  }
  set phone(phone) {
    this._data.phone = phone
  }
  get isDefault() {
    return this._data.isDefault
  }
  set isDefault(isDefault) {
    this._data.isDefault = isDefault || false
  }
  get payee() {
    return this._data.payee
  }
  set payee(payee) {
    this._data.payee = payee
  }
  get auditor() {
    return this._data.auditor
  }
  set auditor(auditor) {
    this._data.auditor = auditor
  }
  get depositBankAccount() {
    return this._data.depositBankAccount
  }
  set depositBankAccount(depositBankAccount) {
    this._data.depositBankAccount = depositBankAccount
  }
  get invoiceChannel() {
    return this._data.invoiceChannel
  }
  set invoiceChannel(invoiceChannel) {
    this._data.invoiceChannel = invoiceChannel
  }
  get appKey() {
    return this._data.appKey
  }
  set appKey(appKey) {
    this._data.appKey = appKey
  }
  get appSecret() {
    return this._data.appSecret
  }
  set appSecret(appSecret) {
    this._data.appSecret = appSecret
  }
  get token() {
    return this._data.token
  }
  set token(token) {
    this._data.token = token
  }

  get inputTaxInvoiceChannel() {
    return this._data.inputTaxInvoiceChannel
  }
  set inputTaxInvoiceChannel(inputTaxInvoiceChannel) {
    this._data.inputTaxInvoiceChannel = inputTaxInvoiceChannel
  }
  get inputTaxAppKey() {
    return this._data.inputTaxAppKey
  }
  set inputTaxAppKey(inputTaxAppKey) {
    this._data.inputTaxAppKey = inputTaxAppKey
  }
  get inputTaxAppSecret() {
    return this._data.inputTaxAppSecret
  }
  set inputTaxAppSecret(inputTaxAppSecret) {
    this._data.inputTaxAppSecret = inputTaxAppSecret
  }
  get inputTaxToken() {
    return this._data.inputTaxToken
  }
  set inputTaxToken(inputTaxToken) {
    this._data.inputTaxToken = inputTaxToken
  }

  get invoiceIssuer() {
    return this._data.invoiceIssuer
  }
  set invoiceIssuer(invoiceIssuer) {
    this._data.invoiceIssuer = invoiceIssuer
  }
  get customField1() {
    return this._data.customField1
  }
  set customField1(customField1) {
    this._data.customField1 = customField1
  }
  get customField2() {
    return this._data.customField2
  }
  set customField2(customField2) {
    this._data.customField2 = customField2
  }
  get customField3() {
    return this._data.customField3
  }
  set customField3(customField3) {
    this._data.customField3 = customField3
  }
  get invoiceConfigs() {
    return this._data.invoiceConfigs || []
  }
  set invoiceConfigs(invoiceConfigs) {
    this._data.invoiceConfigs = invoiceConfigs
  }
  get taxControlPanelUuid() {
    return this._data.taxControlPanelUuid
  }
  set taxControlPanelUuid(taxControlPanelUuid) {
    this._data.taxControlPanelUuid = taxControlPanelUuid
  }
}
